import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import LearningGoal from "./routes/LearningGoal";

export default store => ({
  path: "learning-goals",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "course-gradebook" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [LearningGoal(store)],
});
